// src/components/layout/Layout.js
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children, darkMode, setDarkMode }) => {
  return (
    <div className="layout">
      <Navbar darkMode={darkMode} setDarkMode={setDarkMode}/>
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;